
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Button, Tooltip } from 'ant-design-vue';

@Component({
    name: 'CreateOfferButton',
    components: { Button, Tooltip },
})
export default class CreateOfferButton extends Vue {
    @Prop({ default: false }) private offerHasErrors!: boolean;
    @Prop({ default: true }) private showIcon!: boolean;

    private async openDocumentAndPdfTypePopup() {
        this.$emit('offer-click');
    }
}
